import React, { Component } from 'react'
import './Mon_Medecin.css'
import axios from 'axios'
import ProfMed from './profilNosMed'
import Discussion from './Discussion'
import io from "socket.io-client";
import ls from "local-storage"


class MonMedecin extends Component {
	constructor(props) {
		super(props)
		this.state = {
			userId: ls.get("userId"),
			MedInfos: " ",
			renderProfil: false,
			renderDiscuss: false,
			uerSessionName: "  ",
			MedEnAttentent: " "
		}
		this.handleMessage = this.handleMessage.bind(this)
		this.handleProfil = this.handleProfil.bind(this)
	}

	componentDidMount() {
		axios
			.post('https://flask-api85550.herokuapp.com/getConsMed', this.state)
			.then(response => {
				if (response.data === "attente") {
					this.setState({
						MedEnAttentent: "yes"
					})
				} else {

					this.setState({
						MedInfos: response.data[0]
					})
					axios
						.get('https://flask-api85550.herokuapp.com/getSession')
						.then(response => {
							this.setState({
								uerSessionName: response.data
							})
							let private_mess = io.connect("https://flask-api85550.herokuapp.com/private")
							private_mess.emit("username", this.state);

						})
						.catch(erreur => {
							console.log(erreur)
						})
				}

			})
			.catch(erreur => {
				console.log(erreur)
			})

	}
	handleProfil = () => {
		this.setState({
			renderProfil: true,
			renderDiscuss: false
		})

	}
	handleMessage = () => {
		this.setState({
			renderProfil: false,
			renderDiscuss: true
		})
	}
	render() {
		const renderComp = () => {


			if (this.state.renderProfil === true) {

				return <ProfMed userId={this.state.MedInfos[14]} />
			} else if (this.state.renderDiscuss === true) {
				return <p><Discussion email={this.state.MedInfos[19]} userEmail={this.state.uerSessionName} /></p>
			} else {
				return <p>Notification</p>
			}
		}

		const renderComponent = () => {

			if (this.state.MedEnAttentent === "yes") {

				return (<p>Medecin En attente</p>)
			} else {
				return (
					<div className="container">
						<div className="row profile">
							<div className="col-md-3" id="medecin">
								<div className="profile-usertitle">
									<div className="profile-usertitle-job">
										{this.state.MedInfos[2]}
									</div>
								</div>
								<div className="text-center">
									<img src={this.state.MedInfos[13] || "http://ssl.gstatic.com/accounts/ui/avatar_2x.png"} className="avatar img-circle img-thumbnail" alt="avatar" />
								</div>
								<div className="profile-usertitle-name">
									{this.state.MedInfos[17] + ' ' + this.state.MedInfos[18]}<span className="fa fa-envelope small pull-right"> </span>
								</div>
								<div className="profile-userbuttons">
									<div>
										<button type="button" className="btn btn-primary" id="follow" onClick={() => { this.handleProfil() }}>Profil</button>
									</div>
									<div>
										<button type="button" className="btn btn-primary" id="follow" onClick={() => { this.handleMessage() }}>Discussion</button>
									</div>
								</div>
							</div>
							<div className="col-md-9">
								<div className="profile-content" id="contPat">
									{renderComp()}
								</div>
							</div>
						</div>
					</div>
				)
			}
		}

		return (
			<div>
				{renderComponent()}
				<center>
				</center>
				<br />

			</div>
		)
	}
}
export default MonMedecin